import { AsyncPipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { ActivatedRoute, Router } from "@angular/router";
import { Plugins } from "@capacitor/core";
import { AuthService } from "@core/auth.service";
import { UtilityService } from "@core/utility.service";
import { IonicModule, NavController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { take } from "rxjs/operators";
import { AccountRepositoryService } from "src/app/pages/account/account-repository.service";
import { ChatbotService } from "src/app/services/chatbot.service";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { ChatbotTestComponent } from "../../components/chatbot-test/chatbot-test.component";
import { SafeHtmlPipe } from "../../pipe/safehtmlpipe";

const { Browser } = Plugins;
@Component({
  selector: "app-help-test",
  templateUrl: "./help-test.component.html",
  styleUrls: ["./help-test.component.scss"],
  standalone: true,
  imports: [
    IonicModule,
    MatIcon,
    AsyncPipe,
    SafeHtmlPipe,
    TranslatePipe,
  ],
})
export class HelpTestComponent implements OnInit {
  //languge: string;
  user$ = this.authService?.userDetails$;
  helpContent$ = this.accountService?.helpAndFaq();
  helpSupport = true;
  selectedLanguage: string = "en";
  constructor(
    private navController: NavController,
    private authService: AuthService,
    private accountService: AccountRepositoryService,
    public translate: TranslateService,
    private router: Router,
    private chatboat: ChatbotService,
    private utility: UtilityService,
    private matDialog: MatDialog,
    private route: ActivatedRoute,
    private GTMSegment: GTMSegmentService
  ) {
    this.authService.resetUserRedirect('');// This method is used to reset the user redirect node empty.
    try {
      this.authService?.selectedlanguage$?.pipe(take(1))?.subscribe(
        (l) => {
          this.selectedLanguage = l ? l : "en";
          if (l) {
            translate.use(l ? l : "en");
          }
        },
        (err) => {
          return err;
        }
      );
    } catch (e) { }
  }

  ngOnInit() {
    if (this.route.snapshot.queryParams?.bot_flow && this.route.snapshot.queryParams?.bot_flow != "")
      this.openChatWindow();
  }

  getFurtherData(uri: any) {
    uri += "?lang=" + this.authService?.selectedlanguage$?.value;
    Browser.open({ url: uri });
  }

  openChatWindow() {
    // window["BE_API"].openChatWindow();
    this.GTMSegment.HotJarEvent("chat_initiated");
    const modal = this.matDialog.open(ChatbotTestComponent, {
      height: "100%",
      width: "100%",
    });

    this.router.navigate([], {
      queryParams: {
        "chat-initiated": "1",
      },
      queryParamsHandling: "merge",
    });
  }

  goBack() {
    //this.navController.back();
    this.router.navigateByUrl("mainTabs/tabs/home");
  }
}
